import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate, useLocation } from "react-router-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";
import Modal from 'react-modal';

let UserDetailall = () => {


  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '60%',
      height: '70%',
    },
  };
  const [modalIsOpennew, setIsOpennew] = React.useState(false);


  let [data, setData] = useState();
  const location = useLocation();
  const state = location.state;
  let navigate = useNavigate();

  let [alldata, setAlldata] = useState();
  let [indexs, setIndex] = useState(0);
  let [sel, setSel] = useState("All");
  let [sels, setSels] = useState("tuition");

  let [value, inputvalue] = useState();

  let [editvalutamount, setEditvalutamount] = useState();

  let [dd, setdd] = useState();

  const [isOpen, setIsOpen] = useState(false);

  const [isOpenone, setIsOpenone] = useState(false);
  const [isOpentwo, setIsOpentwo] = useState(false);
  const [paydata, setPaydata] = useState();

  const [name, setName] = useState();
  const [addre, setAddre] = useState();
  const [addno, setAddno] = useState();

  const [pancno, setPanno] = useState();
  const [panname, setPanname] = useState();

  let [ newname , setnewName ] = useState()
  


  //

  const [bankaccno, setBankaccno] = useState();
  const [bankifsc, setBankifsc] = useState();
  const [bankname, setBankname] = useState();
  const [bankholder, setBankholder] = useState();
  const [banknameorg, setBanknameorg] = useState();

  const [allaadhhar, setAllaadhhar] = useState([]);

  useEffect(() => {
    Start();
    User();
   
  }, []);

  function openModal() {
    setIsOpennew(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpennew(false);
  }



  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let User = async () => {
    console.log(state, "state");
    setdd(state);
    setnewName(state?.name)
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, id: state._id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/userdetail",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
          console.log(Jsson.data, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
            setEditvalutamount(Jsson?.data?.wallet[0]?.amount)
            setAlldata(Jsson.data);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }
  };

  function convertAndFormatTimestamp(timestamp, targetTimezone = "en-US") {
    const date = new Date(timestamp);

    const options = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZoneName: "short",
    };

    return date.toLocaleString(targetTimezone, options);
  }

  let changeactive = async () => {
    const userConfirmed = window.confirm(
      "Are you sure you want to change the user status?"
    );

    if (userConfirmed) {
      runFunction();
    } else {
      console.log("User canceled the action.");
    }
  };

  const runFunction = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, id: dd._id, active: dd.active === true ? false : true };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/changeststus",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setdd(Jsson.data);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }
  };

  let searchss = async () => {
    console.log(value, "resultresult");

    if (
      value === "" ||
      value === undefined ||
      value === null ||
      value === "null"
    ) {
      setData(alldata);
    } else {
      let ghu = () => {
        const filteredBbpsPay = data.bbps_pay.filter(
          (payment) =>
            payment.xopayid === value || payment.pg_transactionId === value
        );
        const filteredRentPay = data.rent_pay.filter(
          (payment) =>
            payment.xopay_id === value || payment.pg_transactionId === value
        );

        return {
          aadhar: data.aadhar, // Include all Aadhar details
          bbps_pay: filteredBbpsPay, // Include only matching bbps_pay results
          rent_pay: filteredRentPay, // Include only matching rent_pay results
          Reward_all: data.Reward_all,
          merchant_list: data.merchant_list,
          pan: data.pan,
          rentfees: data.rentfees,
        };
      };
      const result = ghu();

      setData(result);
    }
    console.log(value, "value");
  };


  let aadhars = async () => {

    console.log(dd, 'dd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.id')
    try {
      let token = await localStorage.getItem("token");

      let pp = { aadhar: addno, address: addre, name: name, idss: dd?._id, };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/gst/updateaadhar",
        data: pp,
      })
        .then((dat) => {
          alert("Success");
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }
  }

  let panaa = async () => {

    console.log(dd, 'dd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.iddd?.id')
    try {

      let pp = { aadhar: pancno, name: panname, idss: dd?._id, };

      let apicall = await axios({
        method: "post",
        url: Base_url + "/gst/updatepan",
        data: pp,
      })
        .then((dat) => {
          alert("Success");
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }
  }


  let merchantsubmit = async () => {
    console.log(bankaccno, 'bankaccno')
    console.log(bankifsc, 'bankifsc')
    console.log(bankname, 'bankname')
    console.log(bankholder, 'bankholder')
    console.log(banknameorg, 'banknameorg')
    console.log(sels, 'banknameorg')

    try {

      if (bankaccno === '' || bankaccno === undefined || bankaccno === null) {
        alert('Bank Account No is required')
        return
      }

      if (bankifsc === '' || bankifsc === undefined || bankifsc === null) {
        alert('IFSC is required')
        return
      }

      if (bankname === '' || bankname === undefined || bankname === null) {
        alert('Bank Name is required')
        return
      }

      if (bankholder === '' || bankholder === undefined || bankholder === null) {
        alert('Bank Holder Name is required')
        return
      }

      if (banknameorg === '' || banknameorg === undefined || banknameorg === null) {
        alert('Bank Name is required')
        return
      }

      if (sels === '' || sels === undefined || sels === null) {
        alert('Bank Name is required')
        return
      }

      let pp = { bankaccno, bankifsc, bankname, bankholder, banknameorg, sels, idss: dd?._id };
      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/merchantadds",
        data: pp,
      })
        .then((dat) => {
          alert("Success");
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }
  }


  let Savee = async() =>{
    try {

      let pp = { name : newname , id : dd };

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/updateuser",
        data: pp,
      })
        .then((dat) => {
          alert("Success");
          // setnewName(prev => {
          //   return prev + " updated"; // or any logic
          // })
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }
  }

  let Aadharapicall = async () => {
    console.log(dd._id, "data")
    
    try {

      let pp = { uswerid : dd._id };

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/updateuseraadhar",
        data: pp,
      })
        .then((dat) => {
          console.log(dat.data, "Jsson");
          setAllaadhhar(dat.data.data)
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }


  }


  let Approve = async () => {
     try {

      let pp = { uswerid : dd._id };

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/kycupdate",
        data: pp,
      })
        .then((dat) => {
          console.log(dat.data, "Jsson");

          if(dat.data.status === true){ 
            alert("Approved")
          }

          window.location.reload();
          
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }
  }

  let Reject = async () => {
     try {

      let pp = { uswerid : dd._id };

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/kycrejected",
        data: pp,
      })
        .then((dat) => {
          console.log(dat.data, "Jsson");

          if(dat.data.status === true){ 
            alert("Approved")
          }
          window.location.reload();
          
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }
  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY: 'scroll', height: '100vh', scrollbarWidth: 'none' }} >
          <div className="row">
            <p
              onClick={() => {
                navigate(-1);
              }}
            >
              {"<"} Go back
            </p>
            <div>
              <p style={{ fontWeight: "700", fontSize: 25 }} className="mt-4">
                User Detail
              </p>
            </div>

            <div className="row" style={{ border: "1px solid #ddd", padding: "10px", margin: 10 }} >
              <div className="col-3">
                <div className="row"   >
                  <div className="col-8  ">
                    <p>Name </p>
                    <input value={newname} onChange={(e)=>{ setnewName(e.target.value)}} type="text" style={{ width: "100%" }} placeholder="Name" />
                    {/* User Name : {dd?.name}  */}
                  </div>
                  <div className="col-4">
                    <button onClick={() => {
                      Savee()
                    }} >Save</button>
                  </div>
                </div> 
              </div>
              <div className="col-3">
                
                Phone Number : {dd?.phoneno}
              </div>
              <div className="col-3">
                E mail : {dd?.email}
              </div>
            </div>
            <div className="row">
              <div className="col-5">
                <div style={{ border: "1px solid #ddd", padding: "10px" }}>
                  <p style={{ fontSize: 17, fontWeight: "700" }} onClick={()=>{
                    console.log(  data?.pan , 'data?.pandata?.pan')
                  }} >Pan Detail</p>

                  {data?.pan === "null" || data?.pan === null ? (
                    <>
                      <p
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Empty
                      </p>
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-4">
                          <p style={{ fontSize: 14 }}>Pan name : </p>
                        </div>
                        <div className="col-8">
                          <p style={{ fontSize: 14 }}>
                            {data?.pan?.name_pan_card}{" "}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-4">
                          <p style={{ fontSize: 14 }}>Pan Number : </p>
                        </div>
                        <div className="col-8">
                          <p style={{ fontSize: 14 }}>{data?.pan?.pan} </p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4">
                          <p style={{ fontSize: 14 }}>Masked Aadhaar Number : </p>
                        </div>
                        <div className="col-8">
                          <p style={{ fontSize: 14 }}>{data?.pan?.masked_aadhaar_number} </p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4">
                          <p style={{ fontSize: 14 }}>Date Of Birth : </p>
                        </div>
                        <div className="col-8">
                          <p style={{ fontSize: 14 }}>{data?.pan?.date_of_birth} </p>
                        </div>
                      </div> 
                    </>
                  )}
                </div>
              </div>

              <div className="col-5">
                <div style={{ border: "1px solid #ddd", padding: "10px" }}>

                  <div className="row" >
                    <div className="col-6">
                      <p  style={{ fontSize: 17, fontWeight: "700" }}>
                        Aadhar Detail 
                      </p>
                    </div>
                    <div className="col-6">
                      <button
                        onClick={() => {
                           openModal()

                           Aadharapicall()
                        }}
                      >
                        Show All Aadhar
                      </button>
                    </div>
                          
                  </div >
                 

                  {data?.aadhar === "null" || data?.aadhar === null ? (
                    <>
                      <p
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Empty
                      </p>
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-4">
                          <p style={{ fontSize: 14 }}>Aadhar name : </p>
                        </div>
                        <div className="col-8">
                          <p style={{ fontSize: 14 }}>{data?.aadhar?.name} </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-4">
                          <p style={{ fontSize: 14 }}>Aadhar Number : </p>
                        </div>
                        <div className="col-8">
                          <p style={{ fontSize: 14 }}>
                            {data?.aadhar?.aadhar_no}{" "}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-4">
                          <p style={{ fontSize: 14 }}>Aadhar Address : </p>
                        </div>
                        <div className="col-8">
                          <p style={{ fontSize: 14 }}>
                            {data?.aadhar?.address}{" "}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-4">
                          <p style={{ fontSize: 14 }}>
                            Aadhar date of birth :{" "}
                          </p>
                        </div>
                        <div className="col-8">
                          <p style={{ fontSize: 14 }}>{data?.aadhar?.dob} </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div
                className="col-2"
                style={{
                  display: "flex",
                  flexDirection: "column", // stack vertically
                  justifyContent: "center", // center vertically inside the column
                  alignItems: "center", // center horizontally (optional)
                  gap: "10px", // spacing between buttons
                }}
              >
                <button
                  onClick={() => {
                    changeactive();
                  }}
                  style={{
                    color: "#fff",
                    backgroundColor: dd?.active === true ? "green" : "red",
                  }}
                >
                  {dd?.active === true ? "active" : "blocked"}
                </button>

                <button
                  onClick={() => {
                    console.log(dd, "kkkkkkkkkkkkkkkkkkkk");

                    if (dd?.aadharshow === true || dd?.panshow === true) {
                      setIsOpenone(true)
                    }
                  }}
                  style={{
                    color: "#fff",
                    backgroundColor: dd?.aadharshow === true || dd?.panshow === true ? "green" : "black",
                  }}
                >
                  {dd?.aadharshow === true || dd?.panshow === true === true ? "Kyc Verify" : "Kyc Verified"}
                </button>
              </div>

            </div>

            <div className="row mt-3" >
              <div className="col-6" >
                <p style={{ fontSize: 19, fontWeight: "700", marginTop: 20 }}>
                  Merchant Details
                </p>
              </div  >
              <div className="col-6" >
                <button
                  onClick={() => {
                    setIsOpentwo(true)
                  }}
                >
                  Add Merchant
                </button>
              </div >
            </div >

            {
              data?.merchant_list.length === 0 ?
                '' :
                <div>




                  {
                    <table class="table">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Account no</th>
                          <th scope="col">IFSC</th>
                          <th scope="col">Pan</th>
                          <th scope="col">Pnone No</th>
                          <th scope="col">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.merchant_list?.map((tt, index) => {
                          return (
                            <tr
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                console.log(tt, "vvvvvvv");
                                // togglePanel(tt);
                              }}
                            >
                              <td>{tt?.name}</td>
                              <td>{tt?.bankaccountno}</td>
                              <td>{tt?.ifsc}</td>

                              <td>{tt?.pan}</td>
                              <td>{tt?.phone}</td>
                              <td>{convertAndFormatTimestamp(tt?.createdAt)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  }
                </div>
            }

            {
              data?.Reward_all.length === 0 ?
                "" :
                <div>
                  <p style={{ fontSize: 19, fontWeight: "700", marginTop: 20 }}>
                    Rewards
                  </p>

                  {
                    <table class="table">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col">id</th>
                          <th scope="col">card no</th>
                          <th scope="col">Scratch</th>
                          <th scope="col">Used</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.Reward_all?.map((tt, index) => {
                          return (
                            <tr
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                console.log(tt, "vvvvvvv");
                                // togglePanel(tt);
                              }}
                            >
                              <td>{tt?._id}</td>
                              <td>{tt?.cardid}</td>
                              <td>{tt?.used === true ? "Scratch" : "Not Scratch"}</td>
                              <td>{tt?.pay === true ? "Used" : "Not Used"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  }
                </div>
            }



            <div>
              <p style={{ fontSize: 19, fontWeight: "700", marginTop: 20 }}>
                User Remark
              </p>

              {
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Amount</th>
                      <th scope="col">Remark</th>
                      <th scope="col">Xopayid</th>
                      <th scope="col">Pg transaction id</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.rent_pay?.map((tt, index) => {

                      if (tt?.pay_notes === '' || tt?.pay_notes === undefined || tt?.pay_notes === null) {
                        return
                      }
                      return (
                        <tr
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            console.log(tt, "vvvvvvv");
                            // togglePanel(tt);
                          }}
                        >
                          <td>{tt?.totalamount}</td>
                          <td>{tt?.pay_notes}</td>
                          <td>{tt?.xopay_id}</td>
                          <td>{tt?.pg_transactionId}</td>
                        </tr>
                      );
                    })}


                    {data?.Merchant_payedu?.map((tt, index) => {

                      if (tt?.pay_notes === '' || tt?.pay_notes === undefined || tt?.pay_notes === null) {
                        return
                      }
                      return (
                        <tr
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            console.log(tt, "vvvvvvv");
                            // togglePanel(tt);
                          }}
                        >
                          <td>{tt?.totalamount}</td>
                          <td>{tt?.pay_notes}</td>
                          <td>{tt?.xopay_id}</td>
                          <td>{tt?.pg_transactionId}</td>
                        </tr>
                      );
                    })}


                  </tbody>
                </table>
              }
            </div>


            <div>
              <div className="d-flex justify-content-between" style={{ paddingRight : 20 }}>
                <p style={{ fontSize: 19, fontWeight: "700", marginTop: 20 }}>
                  User Refer code : <span style={{ fontSize: 15, fontWeight: "500", marginTop: 20, marginLeft: 5 }} >{dd?.referid}</span>
                  <p style={{ color : 'red' }}> Reffered user : <span style={{ fontSize: 15, fontWeight: "500",
                     marginTop: 20, marginLeft: 5 }} >{data?.reffereduser?.phoneno}</span>
                  </p>
                </p>

                <p style={{ fontSize: 19, fontWeight: "700", marginTop: 20, color: 'red' }}>
                  Wallet Current Amount :  {data?.Reward_wallet[0]?.amount.toFixed(2)}
                  <div className="row" >
                    <div className="col-6" >
                      <input
                        onChange={(e) => {
                          setEditvalutamount(e.target.value);
                        }}
                        value={editvalutamount}
                        type="text"
                        style={{ width: "100%" }}
                        placeholder="wallet amount"
                      /> 
                    </div>
                    <div className="col-6" >
                      <button onClick={() => {
                        // changewallet()
                      }} >Change</button>
                    </div>
                  </div>
                  
                  
                  
                   {/* <span style={{ fontSize: 15, fontWeight: "500", marginTop: 10, marginLeft: 5 }} >
                    {data?.wallet[0]?.amount}</span>  */}
                </p>

                <p style={{ fontSize: 19, fontWeight: "700", marginTop: 20, color: 'red' }}>
                  Wallet Redeem Amount
                  <span style={{ fontSize: 15, fontWeight: "500", marginTop: 10, marginLeft: 5 }}>
                    {
                      data?.dataWithUsers?.reduce((acc, dd) => acc + Number(dd?.amount || 0), 0) || 0
                    }
                  </span>
                </p>
              </div>


              {
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Phone No</th>
                      <th scope="col">Name</th>
                      <th scope="col">T1 pay amount</th>
                      <th scope="col">Amount get</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.refuser?.map((tt, index) => {

                      
                      return (
                        <tr
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            console.log(tt, "vvvvvvv");
                            // togglePanel(tt);
                          }}
                        >
                          <td>{tt?.alldatass?.phoneno}</td>
                          <td>{tt?.alldatass?.name }</td>
                          <td>{tt?.totalAmountForT1}</td>
                          <td>{tt?.item?.amount }</td>
                        </tr>
                      );
                    })}


                    {data?.Merchant_payedu?.map((tt, index) => {

                      if (tt?.pay_notes === '' || tt?.pay_notes === undefined || tt?.pay_notes === null) {
                        return
                      }
                      return (
                        <tr
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            console.log(tt, "vvvvvvv");
                            // togglePanel(tt);
                          }}
                        >
                          <td>{tt?.totalamount}</td>
                          <td>{tt?.pay_notes}</td>
                          <td>{tt?.xopay_id}</td>
                          <td>{tt?.pg_transactionId}</td>
                        </tr>
                      );
                    })}


                  </tbody>
                </table>
              }
            </div>



            <div>
              <p style={{ fontSize: 19, fontWeight: "700", marginTop: 15 }}>
                Payment Detail
              </p>

              <div className="row">
                <div className="col-3">
                  <select
                    onChange={(e) => {
                      setSel(e.target.value);
                    }}
                    name="cars"
                    id="cars"
                    style={{ width: 150, height: 30, marginBottom: 20 }}
                  >
                    <option value="All" selected={sel === "All" ? true : false}>
                      All
                    </option>
                    <option
                      value="Success"
                      selected={sel === "Success" ? true : false}
                    >
                      Success
                    </option>
                    <option
                      value="Failed"
                      selected={sel === "Failed" ? true : false}
                    >
                      Failed
                    </option>
                    <option
                      value="Refund"
                      selected={sel === "Refund" ? true : false}
                    >
                      Refund
                    </option>
                    <option
                      value="Processing"
                      selected={sel === "Processing" ? true : false}
                    >
                      Processing
                    </option>
                  </select>
                </div>
                <div className="col-3">
                  <input
                    onChange={(e) => {
                      inputvalue(e.target.value);
                    }}
                    type="text"
                    style={{ width: "100%" }}
                    placeholder="Xopayid or pg_transaction id"
                  />
                </div>
                <div className="col-3">
                  <button
                    onClick={() => {
                      searchss();
                    }}
                  >
                    Submit
                  </button>
                </div>
                <div className="col-3"></div>
              </div>

              <div className="row">
                <div
                  className="col-4"
                  style={{ border: "1px solid #ddd", padding: "10px" }}
                >
                  <p style={{ fontSize: 15, fontWeight: "700", marginTop: 15 }}>
                    BBPS ({data?.bbps_pay?.length})
                  </p>

                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">Category</th>
                        <th scope="col">Total</th>
                        <th scope="col">Date</th>
                        <th scope="col">Card no</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.bbps_pay?.map((tt, index) => {
                        if (sel === "All") {
                        } else if (sel === "Success") {
                          if (tt?.payment_status_msg != "Success") {
                            return;
                          }
                        } else if (sel === "Failed") {
                          if (tt?.payment_status_msg != "Failed") {
                            return;
                          }
                        } else if (sel === "Refund") {
                          if (tt?.payment_status_msg != "Refund") {
                            return;
                          }
                        } else if (sel === "Processing") {
                          if (tt?.payment_status_msg != "Progress") {
                            return;
                          }
                        }

                        let ppg = ''
                        // pg_res

                        if (
                          tt?.pg_res === undefined ||
                          tt?.pg_res === null ||
                          tt?.pg_res === "null"
                        ) {
                        } else {
                          ppg = JSON.parse(tt?.pg_res);
                        }

                        return (
                          <tr
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              console.log(tt, "vvvvvvv");
                              // togglePanel(tt);
                              setIsOpen(true);
                              setPaydata(tt);
                            }}
                          >
                            <td>{tt?.category}</td>
                            <td>{tt?.total}</td>
                            <td>{convertAndFormatTimestamp(tt?.createdAt)}</td>
                            <td>{ppg?.data?.payment?.payment_method?.card?.card_number?.slice(-4)}</td>
                            <td
                              style={{
                                color:
                                  tt?.payment_status_msg === "Success"
                                    ? "green"
                                    : tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : tt?.payment_status_msg === "Refund"
                                        ? "red"
                                        : "orange",
                              }}
                            >
                              {tt?.payment_status_msg}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div
                  className="col-4"
                  style={{ border: "1px solid #ddd", padding: "10px" }}
                >
                  <p style={{ fontSize: 15, fontWeight: "700", marginTop: 15 }}>
                    Rent ({data?.rent_pay?.length})
                  </p>

                  <table class="table">
                    <thead class="thead-dark">
                      {/* .data?.payment?.payment_method?.card?.card_number */}
                      <tr>
                        <th scope="col">Category</th>
                        <th scope="col">Total</th>
                        <th scope="col">Date</th>
                        <th scope="col">Card No</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.rent_pay?.map((tt, index) => {


                        if (sel === "All") {
                        } else if (sel === "Success") {
                          if (tt?.payment_status_msg != "Success") {
                            return;
                          }
                        } else if (sel === "Failed") {
                          if (tt?.payment_status_msg != "Failed") {
                            return;
                          }
                        } else if (sel === "Refund") {
                          if (tt?.payment_status_msg != "Refund") {
                            return;
                          }
                        } else if (sel === "Processing") {
                          if (tt?.payment_status_msg != "Processing") {
                            return;
                          }
                        }

                        let ppg = ''
                        // pg_res

                        if (
                          tt?.pg_res === undefined ||
                          tt?.pg_res === null ||
                          tt?.pg_res === "null"
                        ) {
                        } else {
                          ppg = JSON.parse(tt?.pg_res);

                          console.log(ppg, 'ppg -----------------------------------> 88888888888')
                        }

                        let vald = "";
                        if (
                          tt?.charge === undefined ||
                          tt?.charge === null ||
                          tt?.charge === "null"
                        ) {
                        } else {
                          vald = JSON.parse(tt?.charge);
                        }

                        return (
                          <tr
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              console.log(tt, "vvvvvvv");
                              setIsOpen(true);
                              setPaydata(tt);
                              // togglePanel(tt);
                            }}
                          >
                            <td>{vald?.title}</td>
                            <td>{tt?.totalamount}</td>
                            <td>{convertAndFormatTimestamp(tt?.createdAt)}</td>
                            <td  >{ ppg?.card?.card_end || ppg?.data?.payment?.payment_method?.card?.card_number?.slice(-4)}</td>
                            <td
                              style={{
                                color:
                                  tt?.payment_status_msg === "Success"
                                    ? "green"
                                    : tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : tt?.payment_status_msg === "Refund"
                                        ? "red"
                                        : "orange",
                              }}
                            >
                              {tt?.payment_status_msg}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div
                  className="col-4"
                  style={{ border: "1px solid #ddd", padding: "10px" }}
                >
                  <p style={{ fontSize: 15, fontWeight: "700", marginTop: 15 }}>
                    Education ({data?.Merchant_payedu?.length})
                  </p>

                  <table class="table">
                    <thead class="thead-dark">
                      {/* .data?.payment?.payment_method?.card?.card_number */}
                      <tr>
                        <th scope="col">Category</th>
                        <th scope="col">Total</th>
                        <th scope="col">Date</th>
                        <th scope="col">Card No</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.Merchant_payedu?.map((tt, index) => {


                        if (sel === "All") {
                        } else if (sel === "Success") {
                          if (tt?.payment_status_msg != "Success") {
                            return;
                          }
                        } else if (sel === "Failed") {
                          if (tt?.payment_status_msg != "Failed") {
                            return;
                          }
                        } else if (sel === "Refund") {
                          if (tt?.payment_status_msg != "Refund") {
                            return;
                          }
                        } else if (sel === "Processing") {
                          if (tt?.payment_status_msg != "Processing") {
                            return;
                          }
                        }

                        let ppg = ''
                        // pg_res

                        if (
                          tt?.pg_res === undefined ||
                          tt?.pg_res === null ||
                          tt?.pg_res === "null"
                        ) {
                        } else {
                          ppg = JSON.parse(tt?.pg_res);
                        }

                        let vald = "";
                        if (
                          tt?.charge === undefined ||
                          tt?.charge === null ||
                          tt?.charge === "null"
                        ) {
                        } else {
                          vald = JSON.parse(tt?.charge);
                        }

                        return (
                          <tr
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              console.log(tt, "vvvvvvv");
                              setIsOpen(true);
                              setPaydata(tt);
                              // togglePanel(tt);
                            }}
                          >
                            <td>{vald?.title}</td>
                            <td>{tt?.totalamount}</td>
                            <td>{convertAndFormatTimestamp(tt?.createdAt)}</td>
                            <td  >{ppg?.card?.card_end || ppg?.data?.payment?.payment_method?.card?.card_number?.slice(-4)}</td>
                            <td
                              style={{
                                color:
                                  tt?.payment_status_msg === "Success"
                                    ? "green"
                                    : tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : tt?.payment_status_msg === "Refund"
                                        ? "red"
                                        : "orange",
                              }}
                            >
                              {tt?.payment_status_msg}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`side-panel ${isOpen ? "open" : ""}`}>
        <p
          style={{ textAlign: "right", padding: 10, cursor: "pointer" }}
          onClick={() => {
            setIsOpen(false);
          }}
        >
          X
        </p>
        <div className="panel-content">
          <p style={{ fontSize: 17, fontWeight: "700" }}>Payment Data</p>
          {paydata?.category === "Rent" ? (
            <>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Category : {paydata?.category}
              </p>

              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Amount : {paydata?.amount}
              </p>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Gst : {paydata?.gst}
              </p>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Con Fees : {paydata?.confess}
              </p>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                total : {paydata?.totalamount}
              </p>

              <p style={{ fontSize: 17, fontWeight: "700", marginTop: 20 }}>
                Ids
              </p>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Xopayid : {paydata?.xopay_id}
              </p>

              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Pg transaction id : {paydata?.pg_transactionId}
              </p>
            </>
          ) : (
            <>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Category : {paydata?.category}
              </p>

              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Amount : {paydata?.amount}
              </p>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Gst : {paydata?.gst}
              </p>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Con Fees : {paydata?.confess}
              </p>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                total : {paydata?.total}
              </p>

              <p style={{ fontSize: 17, fontWeight: "700", marginTop: 20 }}>
                Ids
              </p>
              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Xopayid : {paydata?.xopay_id}
              </p>

              <p style={{ fontSize: 17, marginBottom: -1 }}>
                Pg transaction id : {paydata?.pg_transactionId}
              </p>
            </>
          )}
        </div>
      </div>




      <div className={`side-panels ${isOpenone ? "open" : ""}`}>
        <p
          style={{ textAlign: "right", padding: 10, cursor: "pointer" }}
          onClick={() => {
            setIsOpenone(false);
          }}
        >
          X
        </p>
        <div className="panel-content">
          {
            dd?.aadharshow === true ?
              <>
                <p style={{ fontSize: 17, fontWeight: "700" }}>Aadhar Detail</p>

                <div className="row" >
                  <div className="col-6">
                    <p>Aadhar No : </p>
                    <input
                      onChange={(e) => {
                        setAddno(e.target.value)
                      }}
                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Aadhar No"
                    />


                    <p className="mt-4" >Aadhar Card Name : </p>
                    <input
                      onChange={(e) => {
                        setAddre(e.target.value)
                      }}
                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Aadhar Card Name"
                    />


                  </div>
                  <div className="col-6">
                    <p>Address : </p>
                    <textarea
                      onChange={(e) => {
                        setName(e.target.value)
                      }}
                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Address"
                    />

                    <button className="mt-4" onClick={() => {
                      aadhars()
                    }} >
                      Submit
                    </button>
                  </div>
                </div>


              </> : ""
          }


          {
            dd?.panshow === true ?
              <>
                <p style={{ fontSize: 17, fontWeight: "700" }}>Aadhar Detail</p>

                <div className="row" >
                  <div className="col-6">
                    <p>Pan No : </p>
                    <input
                      onChange={(e) => {
                        setPanno(e.target.value)
                      }}
                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Pan No"
                    />


                    <p className="mt-4" >Pan Card Name : </p>
                    <input
                      onChange={(e) => {
                        setPanname(e.target.value)
                      }}
                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Pan Card Name"
                    />


                  </div>
                  <div className="col-6">


                    <button className="mt-4" onClick={() => {
                      panaa()
                    }} >
                      Submit
                    </button>
                  </div>
                </div>


              </> : ""
          }
        </div>
      </div>


      <div className={`side-panels ${isOpentwo ? "open" : ""}`}>
        <p
          style={{ textAlign: "right", padding: 10, cursor: "pointer" }}
          onClick={() => {
            setIsOpentwo(false);
          }}
        >
          X
        </p>
        <div className="panel-content">
          <p style={{ fontWeight: '700' }} >Add Merchant</p>
          <div className="row" >
            <div className="col-6" >
              <input
                onChange={(e) => {
                  setBankaccno(e.target.value)
                }}
                type="text"
                style={{ width: "100%" }}
                placeholder="Bank Account No"
                className="mt-2"
              />
              <input
                onChange={(e) => {
                  setBankifsc(e.target.value)
                }}
                type="text"
                style={{ width: "100%" }}
                placeholder="IFSC"
                className="mt-2"
              />
              <input
                onChange={(e) => {
                  setBankholder(e.target.value)
                }}
                type="text"
                style={{ width: "100%" }}
                placeholder="Bank Holder Name"
                className="mt-2"
              />

              <button
                className="mt-2"
                onClick={() => {
                  merchantsubmit()
                }} >
                Submit
              </button>
            </div>



            <div className="col-6" >
              <input
                onChange={(e) => {
                  setBankname(e.target.value)
                }}
                type="text"
                style={{ width: "100%" }}
                placeholder="Name of the bank"
                className="mt-2"
              />

              <input
                onChange={(e) => {
                  setBanknameorg(e.target.value)
                }}
                type="text"
                style={{ width: "100%" }}
                placeholder="Org name like 'Golden gllory college'"
                className="mt-2"
              />

              <select
                onChange={(e) => {
                  setSels(e.target.value);
                }}
                name="cars"
                id="cars"
                className="mt-2"
              >
                <option
                  value="tuition"
                  selected={sels === "tuition" ? true : false}
                >
                  tuition
                </option>
                <option
                  value="college"
                  selected={sels === "college" ? true : false}
                >
                  college
                </option>
                <option
                  value="school"
                  selected={sels === "school" ? true : false}
                >
                  school
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>


      <Modal
        isOpen={modalIsOpennew}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles} 
        contentLabel="Example Modal"
      >
        <div className="d-flex justify-content-end mb-2"> 
          <div style={{ fontSize: 20 , cursor : "pointer" }} onClick={closeModal}>X</div>
        </div>

        <div style={{ padding : 10 }} >
          <p style={{ fontWeight : '600' , marginBottom : 40 }}>User All Aadhar</p>


          {
            allaadhhar?.map(( fgy , ind )=>{
              return (
                <div style={{ marginBottom : 20 , borderBottom : '1px solid #aaaaaaff' }}>
                  <div className="row" >
                    <div className="col-4">
                      <p style={{ fontSize: 14 }}>Aadhar name : </p>
                    </div>
                    <div className="col-8">
                      <p style={{ fontSize: 14 }}>{fgy?.name} </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <p style={{ fontSize: 14 }}>Aadhar Number : </p>
                    </div>
                    <div className="col-8">
                      <p style={{ fontSize: 14 }}>
                        {fgy?.aadhar_no}{" "}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <p style={{ fontSize: 14 }}>Aadhar Address : </p>
                    </div>
                    <div className="col-8">
                      <p style={{ fontSize: 14 }}>
                        {fgy?.address}{" "}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <p style={{ fontSize: 14 }}>
                        Aadhar date of birth :{" "}
                      </p>
                    </div>
                    <div className="col-8">
                      <div className="row">
                        <div className="col-6" >
                          <p style={{ fontSize: 14 }}>{fgy?.dob} </p>
                        </div>
                        <div className="col-6" >
                          <div className="d-flex justify-content-between" >
                            <button onClick={() => {
                              Approve()
                            }} >
                              Approve
                            </button>
                            <button className=" " onClick={() => {
                              Reject()
                            }} >
                              Reject
                            </button>
                          </div>
                        </div> 
                      </div >
                      
                    </div>
                  </div>


                </div>
              )
            })
          }

          {
            allaadhhar?.length === 0 ?
              <div style={{ fontSize: 20 , fontWeight : '700' }}>No data found</div> : "" 
          }

          


        </div>
 
      </Modal>



    </div>
  );
};

export default UserDetailall;
